/**
 * react-helmet-async ships as CommonJS; Vite's SSR module runner cannot
 * resolve its named exports ("Named export 'Helmet' not found"). This shim
 * normalizes the interop for both the browser bundle and SSR.
 */
import * as helmetPkg from "react-helmet-async";

type HelmetModule = typeof import("react-helmet-async");

const resolved: HelmetModule =
  ((helmetPkg as unknown as { default?: HelmetModule }).default ??
    helmetPkg) as HelmetModule;

export const Helmet = resolved.Helmet;
export const HelmetProvider = resolved.HelmetProvider;